<script setup lang="ts">

import CountChip from "@/components/chips/CountChip.vue";
import {useNumber} from "@/composables/number";

const {friendlyFormat} = useNumber()

interface Props {
    tab: string | number;
    value: string | number;
    count: number;
}

const props = defineProps<Props>();
const emit = defineEmits<{ click: [] }>()
</script>

<template>
    <v-tab
        :value="props.value"
        class="rounded-b-0"
        @click="emit('click')"
    >
        <div
            class="text-black"
            :class="{
                'font-weight-bold': props.tab === props.value,
                'font-weight-regular': props.tab !== props.value,
            }"
        >
            <slot />
        </div>
        <count-chip class="ml-1">
            {{ friendlyFormat(props.count) }}
        </count-chip>
    </v-tab>
</template>

<style scoped>

</style>
